import './smart-script-executor';
import './globalize/init-globalize';
import jQuery from 'jquery';
import {initCookies} from '../shared/cookies-extended';
import initFeedback from '../components/feedback';
import initClientUserLocationGetter from './ask-geolocation';
import {initCopyToClipboard, initSocials} from '../components/socials/socials-init';
import utils from './utils';
import '../components/chat';
import {initFAQPage} from '../pages/simple-pages/faq';
import '../components/regional-settings/currency-selector';
import {setRegionalSettings} from '../store/regional-settings-store';
import {setDefaultCurrencyForPriceFormatting} from './vue/filters';
import {initVueGlobalComponents} from '../components/global-vue-components';
import {initAdvertModals} from '../components/modals/global-advert-modals';
import {initFormattedPriceComponent} from '../components/inputs/currency-price';
import './validation';
import './vue/init-for-tests';
import '../components/star-rating';
import '../components/cookie-based-timer';
import '../pages/preview-advert/preview-imports';
import {initValidationLocalization} from './validation-localization/localization';
import {initServicesPage, initContactUsPage} from '../pages/simple-pages/services';
import {initServicePlansPage} from '../pages/services/service-plans';
import openPreviewMixin from './vue/openPreviewMixin';
import {initInternalAuth, initStatistics} from './hommits-api';

window.jQuery = jQuery;

export default {
    utils,
    initCookies,
    initFeedback,
    initClientUserLocationGetter,
    initCopyToClipboard,
    initSocials,
    initFAQPage,
    setDefaultCurrencyForPriceFormatting,
    initFormattedPriceComponent,
    setRegionalSettings,
    initVueGlobalComponents,
    initAdvertModals,
    initValidationLocalization,
    initServicesPage,
    initContactUsPage,
    initServicePlansPage,
    openPreviewMixin,
    initInternalAuth,
    initStatistics,
};
